"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Means = function Means(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.056 6.72a.69.69 0 00-.064-.236c-.012-.02-.016-.044-.028-.064a.706.706 0 00-.2-.208l-5.44-3.428a.66.66 0 00-.676-.016L4.016 5.984a.669.669 0 00-.22.216c-.016.024-.024.048-.036.072a.61.61 0 00-.064.236c0 .02-.016.032-.016.052v6.384c0 .22.112.428.296.548l5.632 3.72c.012.008.024.004.032.008.012.008.016.02.028.024.096.048.2.072.3.072a.615.615 0 00.312-.08c.012-.008.02-.024.032-.032s.024-.004.036-.012l5.436-3.852a.663.663 0 00.276-.536V6.768c.008-.016-.004-.032-.004-.048zm-6.1-2.612l4.232 2.668L9.976 9.5l-4.38-2.9 4.36-2.492zM5 7.78l4.316 2.86v4.796L5 12.584V7.78zm9.752 4.684l-4.12 2.92v-4.74l4.12-2.668v4.488z",
    fill: color
  }));
};
var _default = exports["default"] = Means;